/* eslint-disable no-console */
export const log = console.log
